import {
  ControlledSwitch,
  ControlledTextField,
  FormLayout,
} from "@towersystems/roam-common-native";
import { LayoutNodeInput } from "@towersystems/roam-common/lib/generated-types";
import { useFormContext, useWatch } from "react-hook-form";
import { LayoutNodeActionFormVariants } from "../../../../utilities/layout/constants";

export type LayoutNodeActionFormProps = {
  variant?: LayoutNodeActionFormVariants;
};

export function LayoutNodeActionForm({ variant }: LayoutNodeActionFormProps) {
  const { control } = useFormContext<LayoutNodeInput>();

  const watchedAction = useWatch({
    control: control,
    name: "action",
  });

  const isLinkAction = false; //watchedAction === LayoutNodeActionType.CUSTOM_URL;

  const linkMarkup = isLinkAction ? (
    <FormLayout>
      <ControlledTextField
        control={control}
        label="Label"
        placeholder="Label"
        name="label"
      />
      <FormLayout.Group>
        <ControlledTextField
          control={control}
          label="URL"
          placeholder="URL"
          name="link.url"
        />
        <ControlledSwitch
          control={control}
          name="link.newTab"
          label="Open in New Tab"
        />
      </FormLayout.Group>
    </FormLayout>
  ) : null;

  return linkMarkup;
}
